import styled from "@emotion/styled";
import classNames from "classnames";

import type { ChildConditionEditorProps } from "./ChildConditionEditor";
import { ChildConditionEditor } from "./ChildConditionEditor";
import { EffectConnector } from "./EffectConnector";
import { ConditionsListContainer, ROOT_CONDITION_CLASSNAME } from "./shared";

type ChildConditionsEditorProps = Pick<ChildConditionEditorProps, "onRemoveCondition"> & {
  conditions: ChildConditionEditorProps["condition"][];
  isRootCondition: boolean;
  parentGroupId?: number;
};

export const ChildConditionsEditor = ({
  conditions,
  isRootCondition,
  parentGroupId,
  onRemoveCondition,
}: ChildConditionsEditorProps) => {
  return (
    <ConditionsListContainer
      data-test="conditions-list-container"
      className={classNames({ [ROOT_CONDITION_CLASSNAME]: isRootCondition })}
    >
      {conditions.map((condition, index) => (
        <ChildConditionEditor
          key={condition.id}
          condition={condition}
          index={index}
          group={parentGroupId != null ? `${parentGroupId}` : undefined}
          onRemoveCondition={onRemoveCondition}
        />
      ))}
      {!isRootCondition && <ConditionConnector lineStart="dot" />}
    </ConditionsListContainer>
  );
};

const ConditionConnector = styled(EffectConnector)``;
